(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stream-countdown')) {
    class StreamCountdown extends HTMLElement {
      connectedCallback() {
        this.timeZone = this.dataset.timeZone;
        this.designMode = this.dataset.designMode === 'true';
        this.statusElement = this.querySelector('[data-stream-status]');
        this.dateElement = this.querySelector('[data-stream-date]');
        this.liveLinkElement = this.querySelector('[data-stream-live-link]');
        this.timerElement = this.querySelector('[data-stream-timer]');
        this.editorMessageElement = this.querySelector('[data-stream-editor-message]');
        this.daysElement = this.querySelector('[data-stream-days]');
        this.hoursElement = this.querySelector('[data-stream-hours]');
        this.minutesElement = this.querySelector('[data-stream-minutes]');
        this.streams = [this.dataset.streamOne, this.dataset.streamTwo, this.dataset.streamThree]
          .map((value) => this.parseCentralTime(value))
          .filter((value) => value instanceof Date)
          .sort((first, second) => first.getTime() - second.getTime());
        this.lastRender = '';
        this.render();
        this.interval = window.setInterval(() => this.render(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      parseCentralTime(value) {
        if (!value) return null;

        const trimmedValue = value.trim();
        const isoMatch = trimmedValue.match(/^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})$/);
        const usMatch = trimmedValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
        let year;
        let month;
        let day;
        let hour;
        let minute;

        if (isoMatch) {
          [, year, month, day, hour, minute] = isoMatch.map(Number);
        } else if (usMatch) {
          month = Number(usMatch[1]);
          day = Number(usMatch[2]);
          year = Number(usMatch[3]);
          hour = Number(usMatch[4]);
          minute = Number(usMatch[5]);
          const period = usMatch[6].toUpperCase();
          if (hour < 1 || hour > 12) return null;
          hour = hour % 12 + (period === 'PM' ? 12 : 0);
        } else {
          return null;
        }

        if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return null;

        const targetWallTime = Date.UTC(year, month - 1, day, hour, minute);
        let candidate = targetWallTime;

        for (let attempt = 0; attempt < 3; attempt += 1) {
          const parts = this.zonedParts(candidate);
          const renderedWallTime = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute);
          candidate += targetWallTime - renderedWallTime;
        }

        const verified = this.zonedParts(candidate);
        const isValid =
          verified.year === year &&
          verified.month === month &&
          verified.day === day &&
          verified.hour === hour &&
          verified.minute === minute;

        return isValid ? new Date(candidate) : null;
      }

      zonedParts(timestamp) {
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: this.timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        });
        return Object.fromEntries(
          formatter
            .formatToParts(new Date(timestamp))
            .filter((part) => part.type !== 'literal')
            .map((part) => [part.type, Number(part.value)])
        );
      }

      formatStreamDate(streamDate) {
        const date = new Intl.DateTimeFormat('en-US', {
          timeZone: this.timeZone,
          weekday: 'long',
          month: 'long',
          day: 'numeric',
        }).format(streamDate);
        const time = new Intl.DateTimeFormat('en-US', {
          timeZone: this.timeZone,
          hour: 'numeric',
          minute: '2-digit',
        }).format(streamDate);
        return `${date} ${this.dataset.atLabel} ${time} ${this.dataset.zoneLabel}`;
      }

      render() {
        const now = Date.now();
        const liveWindow = 6 * 60 * 60 * 1000;
        const liveStream = this.streams.find(
          (stream) => stream.getTime() <= now && stream.getTime() + liveWindow > now
        );

        if (liveStream) {
          const renderKey = `live-${liveStream.getTime()}`;
          if (renderKey === this.lastRender) return;
          this.lastRender = renderKey;
          this.hidden = false;
          this.statusElement.textContent = this.dataset.liveLabel;
          this.statusElement.hidden = Boolean(this.liveLinkElement);
          this.dateElement.hidden = true;
          if (this.liveLinkElement) this.liveLinkElement.hidden = false;
          this.timerElement.hidden = true;
          this.editorMessageElement.hidden = true;
          return;
        }

        const nextStream = this.streams.find((stream) => stream.getTime() > now);

        if (!nextStream) {
          const renderKey = this.designMode ? 'editor-empty' : 'hidden';
          if (renderKey === this.lastRender) return;
          this.lastRender = renderKey;
          this.hidden = !this.designMode;
          if (this.designMode) {
            this.statusElement.textContent = this.dataset.editorTitle;
            this.statusElement.hidden = false;
            this.dateElement.textContent = '';
            this.dateElement.hidden = true;
            if (this.liveLinkElement) this.liveLinkElement.hidden = true;
            this.timerElement.hidden = true;
            this.editorMessageElement.textContent = this.dataset.editorMessage;
            this.editorMessageElement.hidden = false;
          }
          return;
        }

        const totalMinutes = Math.max(0, Math.ceil((nextStream.getTime() - now) / 60000));
        const days = Math.floor(totalMinutes / 1440);
        const hours = Math.floor((totalMinutes % 1440) / 60);
        const minutes = totalMinutes % 60;
        const renderKey = `${nextStream.getTime()}-${days}-${hours}-${minutes}`;
        if (renderKey === this.lastRender) return;
        this.lastRender = renderKey;
        this.hidden = false;
        this.statusElement.textContent = this.dataset.nextLabel;
        this.statusElement.hidden = false;
        this.dateElement.textContent = this.formatStreamDate(nextStream);
        this.dateElement.hidden = false;
        if (this.liveLinkElement) this.liveLinkElement.hidden = true;
        this.daysElement.textContent = String(days).padStart(2, '0');
        this.hoursElement.textContent = String(hours).padStart(2, '0');
        this.minutesElement.textContent = String(minutes).padStart(2, '0');
        this.timerElement.setAttribute(
          'aria-label',
          `${days} ${this.dataset.daysLabel}, ${hours} ${this.dataset.hoursLabel}, ${minutes} ${this.dataset.minutesLabel}`
        );
        this.timerElement.hidden = false;
        this.editorMessageElement.hidden = true;
      }
    }

    customElements.define('stream-countdown', StreamCountdown);
  }

  } catch(e) { console.error(e); }
})();
})();
